import "./JSONDropZOne.scss";

interface JSONDropZoneProps {
  getRootProps: () => object;
  getInputProps: () => object;
  open: () => void;
}

export const JSONDropZone = ({
  getRootProps,
  getInputProps,
  open,
}: JSONDropZoneProps) => (
  <div className="dz_container" {...getRootProps()}>
    <input {...getInputProps()} />
    <div className="dz_icon">
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <path
          d="M12 16V8m0 0-3 3m3-3 3 3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 15a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-1a7 7 0 0 0-7-7h-1"
          strokeLinecap="round"
        />
      </svg>
    </div>
    <p className="dz_primary">Drag & drop your walkthrough JSON</p>
    <p className="dz_secondary">
      or{' '}
      <button type="button" className="dz_browse" onClick={open}>
        click to browse
      </button>
    </p>
  </div>
);
